import { useState } from 'react'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'
import MoreIcon from '@/modules/chatting/icons/more.svg'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

import { CollectionsItem } from '../CollectionsList/types'

interface Props {
  onClickAddUsers: () => void
  collection: CollectionsItem
  onDelete: () => void
}

export const CollectionActions = ({
  onClickAddUsers,
  collection,
  onDelete,
}: Props) => {
  const [open, setOpen] = useState(false)

  const handleClickAction = (action: () => void) => () => {
    action()
    setOpen(false)
  }

  const handleClickRename = () => {
    openDialog({
      type: DIALOG_TYPE.RENAME_COLLECTION,
      collection,
    })
  }

  const handleClickClear = () => {
    openDialog({
      type: DIALOG_TYPE.CLEAR_COLLECTION_CONFIRMATION,
      collection,
    })
  }

  const handleClickDelete = () => {
    openDialog({
      type: DIALOG_TYPE.DELETE_COLLECTION_CONFIRMATION,
      collection,
      onDelete,
    })
  }

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
    >
      <PopoverTrigger
        className="outline-none"
        asChild
      >
        <IconButton icon={MoreIcon} />
      </PopoverTrigger>
      <PopoverContent className="z-100 w-[200px] p-2">
        <ActionItem
          label="Rename List"
          onClick={handleClickAction(handleClickRename)}
        />
        <ActionItem
          label="Add Users to List"
          onClick={handleClickAction(onClickAddUsers)}
        />
        <ActionItem
          label="Clear List"
          onClick={handleClickAction(handleClickClear)}
        />
        <ActionItem
          label="Delete List"
          onClick={handleClickAction(handleClickDelete)}
        />
      </PopoverContent>
    </Popover>
  )
}

const ActionItem = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) => {
  return (
    <button
      className="w-full cursor-pointer rounded-md px-3 py-2 text-left text-sm font-medium hover:bg-primary-50 dark:hover:bg-primary-900"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
